import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { defineMessages } from 'react-intl-next';
export var ChoiceMessage = /*#__PURE__*/function (ChoiceMessage) {
  ChoiceMessage["OtherPlaceholder"] = "OtherPlaceholder";
  return ChoiceMessage;
}({});
export var IntlChoiceMessages = defineMessages(_defineProperty({}, ChoiceMessage.OtherPlaceholder, {
  id: 'form-system.ChoiceQuestion.OtherPlaceholder',
  defaultMessage: 'Other...'
}));